import apiClient from "./apiClient";

/**
 * Fetch list of quotations with optional search / filter
 */
export const getQuotations = async (companyCode, options = {}) => {
  try {
    const params = { companyCode };
    if (options.clientId) params.clientId = options.clientId;
    if (options.leadId) params.leadId = options.leadId;
    if (options.companyName) params.companyName = options.companyName;
    if (options.leadCode) params.leadCode = options.leadCode;
    if (options.employeeId) params.employeeId = options.employeeId;
    if (options.search) params.search = options.search;
    if (options.dateFrom) params.dateFrom = options.dateFrom;
    if (options.dateTo) params.dateTo = options.dateTo;
    if (options.page) params.page = options.page;
    if (options.pageSize) params.pageSize = options.pageSize;

    const config = {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    };
    if (options.signal) {
      config.signal = options.signal;
    }

    const data = await apiClient.get("/api/quotations", config);

    const quotations = data?.quotations || data?.items || data?.data || (Array.isArray(data) ? data : []);

    let totalAmount = 0;
    quotations.forEach((q) => {
      totalAmount += Number(q.total || 0);
    });

    return {
      success: true,
      quotations,
      total: data?.total || quotations.length,
      stats: {
        totalAmount,
        quotationCount: quotations.length,
      },
    };
  } catch (error) {
    if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED" || error?.message === "canceled") {
      throw error;
    }
    console.error("[QuotationService] getQuotations error:", error);
    return {
      success: false,
      quotations: [],
      total: 0,
      stats: { totalAmount: 0, quotationCount: 0 },
    };
  }
};

/**
 * Create a new quotation
 */
export const createQuotation = async (companyCode, payload) => {
  try {
    const data = await apiClient.post(
      "/api/quotations",
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return data;
  } catch (error) {
    console.error("[QuotationService] createQuotation error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Update an existing quotation
 */
export const updateQuotation = async (companyCode, id, payload) => {
  try {
    const data = await apiClient.put(
      `/api/quotations/${id}`,
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return data;
  } catch (error) {
    console.error("[QuotationService] updateQuotation error:", error);
    return { success: false, message: error.message };
  }
};

